import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import StripeProvider from './StripeProvider';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StripeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StripeProvider>
  </React.StrictMode>
);

reportWebVitals();
